import { ListItem as MuiListItem, ListItemProps as MuiListItemProps } from "@mui/material";

interface ListItemProps extends MuiListItemProps {
  children?: React.ReactNode;
}

export const ListItem: React.FC<ListItemProps> = ({ children, ...props }) => {
  return <MuiListItem {...props}>{children}</MuiListItem>;
};

export default ListItem;
